var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "world" }, [
    _c("div", { staticClass: "world-bg" }),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrap-hud", attrs: { step: _vm.step } },
      [
        _vm._l(_vm.worldData.mainTerritory, function (territory, index) {
          return _c(
            "div",
            {
              staticClass: "compat-wrap",
              class: {
                full: index === _vm.firstActiveMainTerritoryIndex,
                hide:
                  _vm.step === 2 && index !== _vm.firstActiveMainTerritoryIndex,
                hovered: index === _vm.hoveredTerritoryIndex,
                detail: _vm.isDetail,
              },
              style:
                "transform: translate(" +
                territory.pinPosition.x +
                "px, " +
                territory.pinPosition.y +
                "px) scale(0.26)",
              on: {
                click: function ($event) {
                  return _vm.showZonePin(index)
                },
                mouseenter: function ($event) {
                  return _vm.hoverLinkEnter(index)
                },
                mouseleave: function ($event) {
                  return _vm.hoverLinkLeave(index)
                },
              },
            },
            [
              _c("div", { staticClass: "grill" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "dotted-round",
                style:
                  "transform: translate(-50%, -50%) rotate(" +
                  _vm.dottedRoundDeg +
                  "deg)",
              }),
              _vm._v(" "),
              _c("div", { staticClass: "solid-round" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "quarter",
                style:
                  "transform: translate(0, -100%) rotate(" +
                  _vm.quarterRoundDeg +
                  "deg)",
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "head-bar",
                style:
                  "transform: translate(-50%, -50%) rotate(" +
                  _vm.barRoundDeg +
                  "deg)",
              }),
            ]
          )
        }),
        _vm._v(" "),
        _vm._l(_vm.activeMainTerritoryPins, function (territory, index) {
          return _c(
            "a",
            {
              staticClass: "pin-wrap",
              class: { "big-pin": territory.bigPin },
              style:
                "top: " +
                territory.pinPosition.x +
                "px; left: " +
                territory.pinPosition.y +
                "px",
              attrs: { href: territory.link },
            },
            [
              _c("div", { staticClass: "pin-grill" }),
              _vm._v(" "),
              _c("div", { staticClass: "pin-circle" }),
              _vm._v(" "),
              _vm._l(territory.labels, function (pin) {
                return _c(
                  "div",
                  { staticClass: "label", class: pin.position },
                  [_c("p", { domProps: { innerHTML: _vm._s(pin.name) } })]
                )
              }),
            ],
            2
          )
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "wrap-content-text" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "wrap-content" }, [
          _c("div", { staticClass: "bloc-main-titles" }, [
            _c(
              "h2",
              {
                staticClass: "titre",
                on: {
                  click: function ($event) {
                    return _vm.goBackGlobal()
                  },
                },
              },
              [_vm._t("titre")],
              2
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.worldData.mainTerritory, function (territory, index) {
                return _c("li", [
                  _c("a", {
                    class: { active: index === _vm.activeMainTerritoryIndex },
                    attrs: { href: "" },
                    domProps: { innerHTML: _vm._s(territory.name) },
                    on: {
                      mouseenter: function ($event) {
                        return _vm.hoverLinkEnter(index)
                      },
                      mouseleave: function ($event) {
                        return _vm.hoverLinkLeave(index)
                      },
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.showZone(index)
                      },
                    },
                  }),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "bloc-details",
              class: { "is-detail": _vm.showBlocDetails },
            },
            [_vm._t(_vm.activeMainTerritoryIndexForDetailsInfos)],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "world-globe" }, [
      _c("div", { staticClass: "world-globe-pole" }),
      _vm._v(" "),
      _c("div", { staticClass: "world-globe-doms-container" }),
      _vm._v(" "),
      _c("div", { staticClass: "world-globe-halo" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }